export default {
  common: {
    projectList: "Projektliste",
    pleaseInputProjectName: "Stichwortsuche",
    pipeline: "Pipeline",
    onhold: "Zurückgestellt",
    win: "Gewonnen",
    loss: "Verloren",
    city: "Stadt",
    amount: "Betrag",
    winProbability: "Abschlusswahrscheinlichkeit",
    registeredOn: "Registriert am",
    updatedOn: "Aktualisiert am",
    thereAreNoMoreProjectsLeft: "Es sind keine weiteren Projekte vorhanden",

    drafting: "In Bearbeitung",
    ready: "Bereit",
    shared: "Geteilt",
    negotiating: "In Verhandlung",
    secured: "Gesichert",
    lost: "Verloren",
    onhold: "Zurückgestellt",

    INITIAL: "ECM-Bericht in Vorbereitung",
    ECM_REPORT_PREPARED: "Weitergabe des ECM-Berichts an den Kunden ausstehend",
    ECM_TO_CUSTOMER: "ECM-Bericht an Kunden gesendet",
    CUSTOMER_KIV_PROPOSAL: "Kunde prüft das Angebot weiter",
    CUSTOMER_FUNDED: "Kunde hat die Projektfinanzierung bestätigt",
    CUSTOMER_PROPOSAL: "Kunde verhandelt über das Angebot",
    EA_TO_CUSTOMER: "EA-Bericht an Kunden gesendet",
    CUSTOMER_ORDERS: "Kundenaufträge",
    LOST_TO_COMPETITION: "An Wettbewerber verloren",
    STATUS_PROJECT: "Status in einem anderen Projekt gemeldet",
    IN_ACTIVE: "Projekt zurückgestellt",
    getProjectInfoFailed: "Abrufen der Projektinformationen fehlgeschlagen",
    getCitylistFailed: "Abrufen der Städteliste fehlgeschlagen",
    cantGetProjectDetails: "Projektdetails können nicht abgerufen werden",
    noProjectId: "Keine Projekt-ID",
    noProjectState: "Kein Projektstatus",
    enterProjectName: "Projektnamen eingeben",
    noActualEcmQuoted: "Kein tatsächlicher ECM-Angebotsbetrag",
    submitter: "Einreicher",

    zone: "Gebiet",
    start: "Start",
    end: "Ende",
    clear: "Löschen",
    search: "Suchen",

    details: "Details",
    delete: "Löschen",
    cancel: "Abbrechen",
    report: "Bericht",
    ok: "OK",

    preRetrofitReport: "Bericht vor der Modernisierung",
    postRetrofitReport: "Bericht nach der Modernisierung",
    downloadProjectReport: "Projektdetails und Berichte herunterladen",
    sureDelProject: "Möchten Sie dieses Projekt wirklich löschen?",
    projectDetail: "Ausgabe der Projektdetails",
    status: "Status",
    confirm: "Bestätigen",

    today: "Heute",
    yesterday: "Gestern",
    daysAgo: "Tage zuvor",
    resetLastDate: "Datum der letzten Aktualisierung zurücksetzen",

    sure30days: "Sind Sie sicher, dass Sie in den letzten 30 Tagen keine Aktualisierungen erhalten haben?",
    resetUpdateToToday: "Aktualisierungsdatum auf heute setzen",
    updateOrReset: "Aktualisieren / Zurücksetzen",
    insufficientPermissions: "Unzureichende Berechtigungen",

    projectNotFound: "Projekt nicht gefunden",
    sendToSFDC: "An SFDC senden"
  },
  salesforce: {
    integrationStatus: "Salesforce-Integrationsstatus",
    leadNotApplicable: "Lead-Status nicht anwendbar",
    leadTransferred: "Lead wurde an Salesforce übertragen",
    leadTransferFailed: "Lead-Übertragung fehlgeschlagen",
    opportunityNotApplicable: "Opportunity-Status nicht anwendbar",
    opportunitySynchronized: "Opportunity wurde mit Salesforce synchronisiert",
    opportunitySyncPending: "Synchronisierung der Opportunity ausstehend",
    opportunitySyncFailed: "Synchronisierung der Opportunity fehlgeschlagen",
    lastSyncAttempt: "Letzter Datenübertragungsversuch: {date}",
    lastSynced: "Letzte Datenübertragung: {date}",
    lastAttempt: "Letzter Versuch: {date}",
    lastUpdate: "Letzte Aktualisierung: {date}",
    readyForSFDC: "Bereit für SFDC",
    sentToSFDC: "An SFDC gesendet",
    SFDCTransferFailed: "SFDC-Übertragung fehlgeschlagen",
    SendToSFDCOpportunityTitle: "Salesforce → iECM Spec Builder",
    SendToSFDCOpportunityDescription: "Opportunity zur Analyse an iECM senden. Der abgeschlossene Analysebericht wird einmalig an SFDC zurückübertragen.",
    SendToSFDCLeadTitle: "iECM Spec Builder → Salesforce",
    SendToSFDCLeadDescription: "Lead zur Zuweisung an einen Vertriebsmitarbeiter an SFDC senden. Der Lead wird einmalig in den Lead-Funnel zur Umwandlung in eine Opportunity übernommen."
  },
  projectDlg: {
    newProject: "Neues Projekt",
    projectName: "Projektname",
    projectState: "Projektstatus",
    customer: "Kunde",
    address: "Adresse",
    customerEmail: "E-Mail-Adresse des Kunden",
    auditDate: "Auditmonat",
    jobsiteCity: "Stadt",
    estimatedEcmQuoted: "Geschätzter ECM-Angebotsbetrag",
    exceptedOrder: "Erwarteter Auftrag (Monat/Jahr)",
    winProbability: "Abschlusswahrscheinlichkeit %",
    saveRetrun: "Speichern und zurückkehren",
    saveAudit: "Speichern und prüfen",
    statusRemarks: "Projektanmerkungen",

    actualEcmQuoted: "Tatsächlicher ECM-Angebotsbetrag",
    actualOrder: "Tatsächlicher Auftrag (Monat/Jahr)",

    projectCreationMethod: "Methode der Projekterstellung",

    duplicate: "Projekt kopieren",
    manualInput: "Neues Projekt",
    duplicateFromOtherProject: "Ein vorhandenes Projekt als Vorlage verwenden",
    manuallyInputToCreateProject: "Mit einem leeren Projekt beginnen",

    defaultValue: "Standardwert",
    enterKeyDataUseDefaultValues: "Geben Sie wenige wesentliche Daten ein und verwenden Sie Standardwerte, um ein Projekt zu erstellen",
    copyFrom: "Duplizieren aus",
    enterMoreInformation: "Weitere Informationen eingeben",
    pleaseSelectOne: "Bitte wählen Sie eine Option aus",

    projectNameRequire: "'Projektname' ist erforderlich",
    duplicateFromRequire: "'Duplizieren aus' ist erforderlich",

    stateIn1CantEditIn2: "Der Status dieses Projekts im System 1.0 ist Gewonnen, Verloren oder Zurückgestellt. Daher kann es im System 2.0 nicht bearbeitet werden.",
    lastUpdateDate: "Datum der letzten Aktualisierung",

    intelligentInsightfulImpactful: "Intelligente Energieeinsparmaßnahmen",
    carriersSoftware:
      "iECM-Spezifikationsassistent für die Modernisierung von Kälte- und Wärmezentralen: Erstellen Sie eine neue Spezifikation oder reagieren Sie auf eine von anderen erstellte Spezifikation.",
    intelligent: "Intelligent",
    intelligentDetails:
      "Neue Ausschreibungsspezifikation erstellen → proaktiv (Vertriebschance gestalten) oder bestehende Ausschreibungsanforderungen prüfen und beantworten → reaktiv (Beantwortung einer Angebotsanfrage/Ausschreibung).",
    insightful: "Aufschlussreich",
    insightfulDetails:
      "Vergleichen Sie die vorgeschlagene Auslegung mit festgelegten Wirkungsgradzielen, definieren Sie die Regelungsstrategie und untermauern Sie diese mit einer klaren Leistungsgarantie.",
    impactful: "Wirkungsvoll",
    impactfulDetails: "Erstellen Sie ein kundenfertiges Angebot und ein überzeugendes Gegenangebot, unterstützt durch Wirkungsgradvergleiche, Diagramme, ROI und Amortisationszeit.",
    startNewAnalysis: "MODERNISIERUNGSSPEZIFIKATION STARTEN",

    reassignProject: "Projekt neu zuweisen",
    advancedSearch: "Erweiterte Suche",
    viewAuditData: "Auditdaten anzeigen",

    customerID: "Kunden-ID",
    copyFromSalesforce: "Aus Salesforce kopieren"
  },

  downloadReportDlg: {
    retrofitSolution: "Modernisierungslösung",
    proposal: "vorschlag",
    proposalUpper: "Vorschlag",
    autoConfig: "Automatische Konfiguration",
    userConfig: "Benutzerdefinierte Konfiguration"
  },
  wizardDlg: {
    quickAssessmentMode: "Schnellbewertung",
    quickAssessmentModeDetails: "Geführter Assistent zur schnellen Bewertung von Potenzialen",
    detailedAssessmentMode: "Detaillierte Bewertung",
    detailedAssessmentModeDetails: "Vollständige Analyse für einen validierten Kundenvorschlag",
    title: "iECM"
  }
}



// WEBPACK FOOTER //
// ./src/locale/projectList/de.js